// Cache configuration
const cacheDays = 7;
const CACHE_KEY = 'draft_messages_cache';

function getCache() {
  try {
    const cache = localStorage.getItem(CACHE_KEY);
    return cache ? JSON.parse(cache) : null;
  } catch (error) {
    console.error('[draftMessagesCache] Error reading cache:', error);
    return null;
  }
}

function setCache(cache) {
  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(cache));
  } catch (error) {
    console.error('[draftMessagesCache] Error writing cache:', error);
  }
}

/**
 * Pull draft for a specific chat from cache
 * @param {string} chatId - The chat ID to get draft for
 * @returns {string|null} Draft text or null if not found
 */
export function pullDraft(chatId) {
  const cache = getCache();
  if (!cache) return null;
  
  const draftEntry = cache[chatId];
  if (!draftEntry) return null;
  
  // Check if draft is expired
  const draftDate = new Date(draftEntry.updatedAt);
  const now = new Date();
  const cutoffDate = new Date(now.getTime() - cacheDays * 24 * 60 * 60 * 1000);
  
  if (draftDate < cutoffDate) {
    // Draft is expired, remove it
    delete cache[chatId];
    setCache(cache);
    return null;
  }
  
  return draftEntry.text;
}

/**
 * Save draft for a specific chat to cache
 * @param {string} chatId - The chat ID to save draft for
 * @param {string} text - The draft text to save
 */
export function saveDraft(chatId, text) {
  const cache = getCache() || {};
  
  cache[chatId] = {
    text,
    updatedAt: new Date().toISOString(),
  };
  
  // Clean up old drafts
  const now = new Date();
  const cutoffDate = new Date(now.getTime() - cacheDays * 24 * 60 * 60 * 1000);
  
  Object.entries(cache).forEach(([id, entry]) => {
    const entryDate = new Date(entry.updatedAt);
    if (entryDate < cutoffDate) {
      delete cache[id];
    }
  });
  
  setCache(cache);
}

/**
 * Clear draft for a specific chat from cache
 * @param {string} chatId - The chat ID to clear draft for
 */
export function clearDraft(chatId) {
  const cache = getCache();
  if (!cache) return;
  
  delete cache[chatId];
  setCache(cache);
}
